import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

const Layout = ({ children }) => {
  const location = useLocation();
  const [title, setTitle] = useState("");
  const { batchId } = useParams();

  const routeTitleMap = {
  "/dashboard": "Dashboard",
  "/participants": "Participants",
  "/lifestyle": "Lifestyle/Activity",
  "/speakers": "Speakers",
  "/sponsors": "Sponsors",
  "/livestream": "Livestreams",
  "/allevent": "All Events",
  "/addnewevent": "Add New Event",
  "/category": "Category",
  "/orders": "Orders",
  "/settings": "Settings",
  "/settings/payment-gateway": "Payment Gateway",
  "/location": "Location",
  "/language": "Language",
  "/registeredusers": "Registered Users",
};

useEffect(() => {
  const path = location.pathname;

  // Exact match
  if (routeTitleMap[path]) {
    setTitle(routeTitleMap[path]);
    return;
  }

  // Dynamic route handling
  if (path.startsWith("/student/")) {
    setTitle("Students View");
    return;
  }

  // Fallback
  setTitle("Dashboard");
}, [location.pathname]);


  return (
    <>
      {localStorage.getItem("token") ? (
        <div className="d-flex">
          <Sidebar />
          <div className="nav-content">
            <Navbar title={title} />
            <div className="children">
              {children}
              <Outlet />
            </div>
          </div>
        </div>
      ) : (
        (window.location.href = "/login")
      )}
    </>
  );
};

export default Layout;
